import React from 'react';
import { ArrowRight, Users, Building2, Award } from 'lucide-react';
import { Button } from './ui/button';
import { familyData } from '../mock';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="min-h-screen flex items-center bg-gradient-to-br from-slate-50 to-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-slate-50 opacity-50"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 relative">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="space-y-8 animate-in fade-in-0 duration-1000">
            <div className="space-y-4">
              <div className="inline-flex items-center px-4 py-2 rounded-full bg-slate-100 text-slate-700 text-sm font-medium">
                <Award className="w-4 h-4 mr-2" />
                Desde {familyData.established} em {familyData.location}
              </div>
              
              <h1 className="text-4xl md:text-6xl font-bold text-slate-900 leading-tight">
                Grupo{' '}
                <span className="bg-gradient-to-r from-slate-700 to-slate-900 bg-clip-text text-transparent">
                  Martins Ribeiro
                </span>
              </h1>
              
              <p className="text-xl text-slate-600 leading-relaxed max-w-2xl">
                Uma holding familiar consolidada em Goiás, gerenciando empresas de excelência 
                nos setores de varejo, indústria e construção civil há mais de quatro décadas.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 py-8">
              <div className="text-center">
                <div className="flex items-center justify-center w-12 h-12 bg-slate-100 rounded-lg mb-3 mx-auto">
                  <Building2 className="w-6 h-6 text-slate-700" />
                </div>
                <div className="text-2xl font-bold text-slate-900">3</div>
                <div className="text-sm text-slate-600">Empresas</div>
              </div>
              
              <div className="text-center">
                <div className="flex items-center justify-center w-12 h-12 bg-slate-100 rounded-lg mb-3 mx-auto">
                  <Users className="w-6 h-6 text-slate-700" />
                </div>
                <div className="text-2xl font-bold text-slate-900">45+</div>
                <div className="text-sm text-slate-600">Anos</div>
              </div>
              
              <div className="text-center">
                <div className="flex items-center justify-center w-12 h-12 bg-slate-100 rounded-lg mb-3 mx-auto">
                  <Award className="w-6 h-6 text-slate-700" />
                </div>
                <div className="text-2xl font-bold text-slate-900">100%</div>
                <div className="text-sm text-slate-600">Familiar</div>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                onClick={() => scrollToSection('historia')}
                size="lg"
                className="bg-slate-800 hover:bg-slate-900 text-white px-8 py-3 text-lg font-semibold rounded-lg transition-all duration-200 transform hover:scale-105 group"
              >
                Conheça Nossa História
                <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform duration-200" />
              </Button>
              
              <Button 
                onClick={() => scrollToSection('empresas')}
                variant="outline"
                size="lg"
                className="border-2 border-slate-300 text-slate-700 hover:bg-slate-50 px-8 py-3 text-lg font-semibold rounded-lg transition-all duration-200 transform hover:scale-105"
              >
                Nossas Empresas
              </Button>
            </div>
          </div>

          {/* Visual Element */}
          <div className="lg:flex justify-center items-center animate-in fade-in-0 duration-1000 delay-300">
            <div className="relative">
              <div className="w-80 h-80 bg-gradient-to-br from-slate-100 to-slate-200 rounded-3xl flex items-center justify-center shadow-2xl transform rotate-3 hover:rotate-0 transition-transform duration-500">
                <div className="text-center space-y-4">
                  <div className="w-20 h-20 bg-gradient-to-br from-slate-700 to-slate-900 rounded-2xl flex items-center justify-center mx-auto">
                    <span className="text-white font-bold text-3xl">MR</span>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-slate-800">Tradição</h3>
                    <p className="text-slate-600">& Inovação</p>
                  </div>
                </div>
              </div>
              
              {/* Floating Elements */}
              <div className="absolute -top-4 -right-4 w-16 h-16 bg-white rounded-full shadow-lg flex items-center justify-center animate-bounce">
                <Building2 className="w-8 h-8 text-slate-700" />
              </div>
              
              <div className="absolute -bottom-4 -left-4 w-12 h-12 bg-slate-800 rounded-full shadow-lg flex items-center justify-center animate-pulse">
                <Award className="w-6 h-6 text-white" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;